import { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  createStudentLandingPage,
  getStudentLandingPage,
  updateStudentLandingPage,
} from '../api/studentLandingApi'
import { fetchCompanyOptions } from '../../../../api/filterOptionApi/companyFilterApi'
import { fetchBranchOptions } from '../../../../api/filterOptionApi/branchFilterApi'
import { getMasterOptionItems } from '../../students/api/mastersApi'

const ADMISSION_FORM_HTML = `<div style="max-width:800px;margin:0 auto;font-family:Arial,sans-serif;color:#333;line-height:1.5;">

<!-- ═══════════ HEADER BANNER ═══════════ -->
<div style="text-align:center;padding:18px 0 14px;margin-bottom:22px;border-bottom:3px solid #c0392b;">
<h1 style="color:#c0392b;margin:0;font-size:24px;letter-spacing:0.5px;">NATIONAL ACADEMY</h1>
<p style="color:#e74c3c;margin:4px 0 0;font-size:13px;font-style:italic;">Nurturing Minds</p>
</div>

<h2 style="text-align:center;color:#2c3e50;font-size:20px;letter-spacing:2px;margin:0 0 22px;text-transform:uppercase;">Admission Form</h2>

<!-- ═══════════ PERSONAL DETAILS ═══════════ -->
<div style="border:1px solid #ddd;margin-bottom:18px;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Personal Details</div>
<div style="padding:12px 14px;">
<table style="width:100%;border-collapse:collapse;font-size:13px;">
<tr>
<td style="padding:5px 0;width:50%;vertical-align:top;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:120px;font-weight:bold;font-size:12px;">First Name</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:120px;font-weight:bold;font-size:12px;">Middle Name</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:120px;font-weight:bold;font-size:12px;">Last Name</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:120px;font-weight:bold;font-size:12px;">Email</label>
<input type="email" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:120px;font-weight:bold;font-size:12px;">Mobile</label>
<input type="tel" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;">
<label style="width:120px;font-weight:bold;font-size:12px;">Whatsapp No</label>
<input type="tel" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
</td>
<td style="padding:5px 0 5px 14px;width:50%;vertical-align:top;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Birth Date</label>
<input type="date" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Gender</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Male</option>
<option>Female</option>
<option>Other</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Nationality</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Religion</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">Select</option>
<option>Hindu</option>
<option>Islam</option>
<option>Christian</option>
<option>Sikhism</option>
<option>Jainism</option>
<option>Buddhism</option>
<option>Other</option>
</select>
</div>
<div style="margin-left:116px;margin-bottom:6px;">
<label style="display:block;font-weight:bold;font-size:12px;margin-bottom:3px;">Latest Passport size photo</label>
<input type="file" accept="image/*" style="font-size:12px;" />
</div>
</td>
</tr>
</table>
</div>
</div>

<!-- ═══════════ GUARDIAN DETAILS + ADDRESS ═══════════ -->
<table style="width:100%;border-collapse:collapse;margin-bottom:18px;" cellpadding="0" cellspacing="0">
<tr>
<td style="width:50%;vertical-align:top;padding-right:8px;">
<div style="border:1px solid #ddd;height:100%;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Guardian Details</div>
<div style="padding:12px 14px;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:80px;font-weight:bold;font-size:12px;">Name</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:80px;font-weight:bold;font-size:12px;">Mobile</label>
<input type="tel" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:80px;font-weight:bold;font-size:12px;">Email</label>
<input type="email" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;">
<label style="width:80px;font-weight:bold;font-size:12px;">Relation</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">Select</option>
<option>Father</option>
<option>Mother</option>
<option>Spouse</option>
<option>Other</option>
</select>
</div>
</div>
</div>
</td>
<td style="width:50%;vertical-align:top;padding-left:8px;">
<div style="border:1px solid #ddd;height:100%;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Address</div>
<div style="padding:12px 14px;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:90px;font-weight:bold;font-size:12px;">Line 1</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:90px;font-weight:bold;font-size:12px;">Line 2</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:90px;font-weight:bold;font-size:12px;">Line 3</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:90px;font-weight:bold;font-size:12px;">City</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;">
<label style="width:90px;font-weight:bold;font-size:12px;">Pin Code</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
</div>
</div>
</td>
</tr>
</table>

<!-- ═══════════ COURSE DETAILS + OTHER DETAILS ═══════════ -->
<table style="width:100%;border-collapse:collapse;margin-bottom:18px;" cellpadding="0" cellspacing="0">
<tr>
<td style="width:50%;vertical-align:top;padding-right:8px;">
<div style="border:1px solid #ddd;height:100%;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Course Details</div>
<div style="padding:12px 14px;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:130px;font-weight:bold;font-size:12px;">Mode of Learning</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Regular</option>
<option>Distance</option>
<option>Online</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:130px;font-weight:bold;font-size:12px;">Admission Center</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Kurla</option>
<option>Borivali</option>
<option>Dadar</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:130px;font-weight:bold;font-size:12px;">Course Type</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Certificate</option>
<option>Diploma</option>
<option>Degree</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:130px;font-weight:bold;font-size:12px;">Course</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">Select</option>
<option>Phonics Teacher Training</option>
<option>Learning Disability</option>
<option>Psychological Counselling</option>
<option>Pre- Primary Teacher Training</option>
<option>Early Child Care and Education</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;">
<label style="width:130px;font-weight:bold;font-size:12px;font-size:11px;">How did you come to know about us?</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Newspaper</option>
<option>Internet</option>
<option>Friend / Referral</option>
<option>Social Media</option>
<option>Other</option>
</select>
</div>
</div>
</div>
</td>
<td style="width:50%;vertical-align:top;padding-left:8px;">
<div style="border:1px solid #ddd;height:100%;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Other Details</div>
<div style="padding:12px 14px;">
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Occupation</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">Select</option>
<option>Home Maker</option>
<option>Working Professional</option>
<option>Student</option>
<option>Self Employed</option>
<option>Other</option>
</select>
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Highest Qualification</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Qualification</label>
<input type="text" style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;" />
</div>
<div style="margin-left:116px;margin-bottom:10px;">
<input type="file" style="font-size:12px;" />
</div>
<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px;">
<label style="width:110px;font-weight:bold;font-size:12px;">Id Proof</label>
<select style="flex:1;border:1px solid #ccc;padding:5px 8px;font-size:12px;border-radius:2px;">
<option value="">-- Select --</option>
<option>Aadhaar Card</option>
<option>PAN Card</option>
<option>Passport</option>
<option>Voter ID</option>
<option>Driving License</option>
</select>
</div>
<div style="margin-left:116px;">
<input type="file" style="font-size:12px;" />
</div>
</div>
</div>
</td>
</tr>
</table>

<!-- ═══════════ WORK EXPERIENCE ═══════════ -->
<div style="border:1px solid #ddd;margin-bottom:18px;">
<div style="background:#2c3e50;color:#fff;padding:8px 14px;font-size:13px;font-weight:bold;text-transform:uppercase;">Work Experience</div>
<table style="width:100%;border-collapse:collapse;font-size:12px;">
<thead>
<tr style="background:#ecf0f1;">
<th style="padding:7px 10px;text-align:left;width:40px;border:1px solid #ddd;">#</th>
<th style="padding:7px 10px;text-align:left;border:1px solid #ddd;">Designation</th>
<th style="padding:7px 10px;text-align:left;border:1px solid #ddd;">Duration Of Experience</th>
<th style="padding:7px 10px;text-align:left;border:1px solid #ddd;">Name Of The Organisation</th>
</tr>
</thead>
<tbody>
<tr>
<td style="padding:7px 10px;border:1px solid #ddd;text-align:center;">1</td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
</tr>
<tr>
<td style="padding:7px 10px;border:1px solid #ddd;text-align:center;">2</td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
</tr>
<tr>
<td style="padding:7px 10px;border:1px solid #ddd;text-align:center;">3</td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
<td style="padding:4px;border:1px solid #ddd;"><input type="text" style="width:100%;border:1px solid #ccc;padding:4px 6px;font-size:12px;border-radius:2px;box-sizing:border-box;" /></td>
</tr>
</tbody>
</table>
</div>

<!-- ═══════════ SUBMIT FORM TAG ═══════════ -->
<div style="text-align:center;padding:16px 0 8px;font-size:16px;font-weight:bold;color:#2c3e50;letter-spacing:1px;">#SubmitForm#</div>

</div>`

const emptyForm = {
  name: '',
  companyId: '',
  branchId: '',
  company: '',
  branch: '',
  html: ADMISSION_FORM_HTML,
}

export function useStudentLandingEntryScreen() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useMemo(() => new URLSearchParams(location.search), [location.search])
  const entryId = params.get('id')
  const isViewMode = params.get('view') === '1'

  const [form, setForm] = useState(emptyForm)
  const [companyOptions, setCompanyOptions] = useState([])
  const [branchOptions, setBranchOptions] = useState([])
  const [isLoading, setIsLoading] = useState(Boolean(entryId))
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  useEffect(() => {
    let isMounted = true
    async function loadDropdowns() {
      try {
        const compRes = await fetchCompanyOptions('', 1, 100)
        let comps = compRes?.items || []
        if (comps.length === 0) {
          const masterItems = await getMasterOptionItems('institutes')
          comps = (masterItems || []).map((m) => ({ value: String(m.id || 1), label: m.name }))
        }
        if (isMounted) setCompanyOptions(comps)
      } catch {
        if (isMounted) setCompanyOptions([])
      }

      try {
        const brRes = await fetchBranchOptions('', 1, 100)
        let branches = brRes?.items || []
        if (branches.length === 0) {
          const masterItems = await getMasterOptionItems('branches')
          branches = (masterItems || []).map((m) => ({ value: String(m.id || 1), label: m.name }))
        }
        if (isMounted) setBranchOptions(branches)
      } catch {
        if (isMounted) setBranchOptions([])
      }
    }

    loadDropdowns()
    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    const loadEntry = async () => {
      if (!entryId) {
        setIsLoading(false)
        return
      }

      setIsLoading(true)
      try {
        const item = await getStudentLandingPage(entryId)
        if (item) {
          setForm({
            id: item.id,
            name: item.name || '',
            companyId: item.companyId ? String(item.companyId) : '',
            branchId: item.branchId ? String(item.branchId) : '',
            company: item.company || '',
            branch: item.branch || '',
            html: item.html || ADMISSION_FORM_HTML,
          })
        }
      } catch (requestError) {
        setError('Unable to load landing page details.')
      } finally {
        setIsLoading(false)
      }
    }

    loadEntry()
  }, [entryId])

  const patchForm = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }))
  }

  const handleCompanyChange = (val) => {
    const selected = companyOptions.find((c) => String(c.value) === String(val))
    setForm((prev) => ({
      ...prev,
      companyId: val ? String(val) : '',
      company: selected ? selected.label : '',
    }))
  }

  const handleBranchChange = (val) => {
    const selected = branchOptions.find((b) => String(b.value) === String(val))
    setForm((prev) => ({
      ...prev,
      branchId: val ? String(val) : '',
      branch: selected ? selected.label : '',
    }))
  }

  const validate = () => {
    const nameStr = (form.name || '').trim()
    const htmlStr = (form.html || '').trim()
    const companyIdNum = Number(form.companyId || 0)
    const branchIdNum = Number(form.branchId || 0)

    if (nameStr.length < 5) {
      setError('Name should have atleast 5 characters')
      return false
    }
    if (!htmlStr) {
      setError('Page HTML cannot be blank')
      return false
    }
    if (companyIdNum <= 0) {
      setError('Please select the default company')
      return false
    }
    if (branchIdNum <= 0) {
      setError('Please select the default branch')
      return false
    }
    return true
  }

  const handleSave = async () => {
    if (!validate()) return

    setIsSaving(true)
    setError('')

    try {
      const companyIdNum = Number(form.companyId || 0)
      const branchIdNum = Number(form.branchId || 0)
      const payload = {
        name: form.name.trim(),
        company: form.company,
        branch: form.branch,
        companyId: companyIdNum,
        branchId: branchIdNum,
        html: form.html,
      }

      if (entryId) {
        await updateStudentLandingPage(entryId, payload)
        setSuccess('Landing page updated successfully.')
      } else {
        await createStudentLandingPage(payload)
        setSuccess('Landing page created successfully.')
      }

      setTimeout(() => {
        navigate('/admission/student-landing/list')
      }, 600)
    } catch (requestError) {
      const detail = requestError?.response?.data?.detail
      const msg = typeof detail === 'object' && detail?.message
        ? detail.message
        : typeof detail === 'string'
        ? detail
        : requestError?.response?.data?.message || 'Failed to save the landing page.'
      setError(msg)
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      form,
      isLoading,
      isSaving,
      error,
      success,
      isEditMode: Boolean(entryId),
      isViewMode,
      options: {
        companyOptions,
        branchOptions,
      },
    },
    actions: {
      patchForm,
      handleCompanyChange,
      handleBranchChange,
      handleSave,
      setError,
    },
  }
}

